function toAmountNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * The billable dollar amount of an invoice, in the same order of preference the
 * BL-227/BL-228 invoice paths populate: `total` is the authoritative figure
 * (subtotal + tax + convenience_fee), with the draft-stage fallbacks behind it.
 */
export function resolveInvoiceAmount(invoice) {
  const candidates = [
    invoice?.total,
    invoice?.final_amount,
    invoice?.quoted_amount,
    invoice?.subtotal,
  ];

  for (const candidate of candidates) {
    const amount = toAmountNumber(candidate);
    if (amount !== null && amount > 0) return amount;
  }

  return null;
}
